import React, {useState} from "react"
import {Drawer, IconButton, Box, Typography, Link} from "@mui/material"
import MenuIcon from "@mui/icons-material/Menu"
import img from "../assets/logo.png"
import insta from "../assets/webp/instagram.webp"
import yemeksepeti from "../assets/webp/yemeksepeti.webp"
import location from "../assets/webp/location.webp"
import LanguageSelector from "./LanguageSelector"
import {useLanguage} from "../context/LanguageContext"

export default function Header() {
  const {language} = useLanguage()

  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return
    }
    setIsDrawerOpen(open)
  }
  const drawerContent = () => {
    const content = {
      EN: {
        title: "About Cafe38",
        body: "Cafe 1938 is a venue established in 1938 that honors the rich heritage of Doğan Türk Birliği. It celebrates community spirit and passion for sports. The atmosphere, filled with memories, offers an experience where the past and present meet. Whether you're a long-time fan or looking for a place to enjoy sports, Cafe 1938 welcomes you.",
        instagram: "Follow us on Instagram",
      },
      TR: {
        title: "Cafe38 Hakkında",
        body: "Cafe 1938, 1938'de kurulan ve Doğan Türk Birliği'nin mirasını onurlandıran bir mekandır. Topluluk ruhunu ve spora olan tutkuyu yaşatıyor. Anılarla dolu atmosferi, geçmiş ve bugünün buluştuğu bir deneyim sunuyor. İster hayranı olun, ister spor keyfi arayın, Cafe 1938 kapılarını açıyor.",
        instagram: "Instagram'da bizi takip edin",
      },
    }

    return (
      <Box
        sx={{
          width: 250,
          padding: 2,
          bgcolor: "#111",
          color: "white",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
        role="presentation"
        onClick={toggleDrawer(false)}
        onKeyDown={toggleDrawer(false)}
      >
        <Box>
          <Typography
            variant="h6"
            sx={{textAlign: "center", marginBottom: "25px", marginTop: "10px"}}
          >
            {content[language]?.title}
          </Typography>
          <Typography variant="body1">{content[language]?.body}</Typography>
        </Box>
        <Box sx={{marginTop: "auto"}}>
          <Link
            href="tel:+90 533 874 19 38"
            target="_blank"
            rel="noopener"
            color="inherit"
            sx={{display: "block", textAlign: "center", textDecoration: "none"}}
          >
            <Typography variant="body2">+90 533 874 19 38</Typography>
          </Link>
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              borderTop: "1px solid #3b3b3bd8",
              paddingTop: "15px",
            }}
          >
            <Link
              href="https://www.instagram.com/cafe1938?igsh=YzE5N2tsNTB1bGVn"
              target="_blank"
              rel="noopener"
              color="inherit"
              sx={{display: "block", textAlign: "center"}}
            >
              <img
                src={insta}
                alt="Instagram"
                style={{width: "35px", height: "35px"}}
              />
            </Link>
            <Link
              href="https://yemeksepeti.page.link/EXBz8Ra7sBT2xheH6"
              target="_blank"
              rel="noopener"
              color="inherit"
              sx={{display: "block", textAlign: "center"}}
            >
              <img
                src={yemeksepeti}
                alt="YemekSepeti"
                style={{width: "35px", height: "35px", borderRadius: "30px"}}
              />
            </Link>

            <Link
              href="https://maps.app.goo.gl/C9SdB94xeifKmfn38"
              target="_blank"
              rel="noopener"
              color="inherit"
              sx={{display: "block", textAlign: "center"}}
            >
              <img
                src={location}
                alt="Location"
                style={{width: "35px", height: "35px", borderRadius: "30px"}}
              />
            </Link>
          </div>
        </Box>
      </Box>
    )
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px",
        backgroundColor: "#000",
        color: "white",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
      }}
    >
      <div style={{flex: 1, display: "flex", justifyContent: "left"}}>
        <img
          src={img}
          alt="Logo"
          style={{width: "150px", height: "auto", fontWeight: "bold"}}
        />
      </div>
      <LanguageSelector />
      <IconButton
        edge="end"
        color="inherit"
        aria-label="menu"
        onClick={toggleDrawer(true)}
      >
        <MenuIcon />
      </IconButton>
      <Drawer anchor="right" open={isDrawerOpen} onClose={toggleDrawer(false)}>
        {drawerContent()}
      </Drawer>
    </div>
  )
}
